export const Page404 = () => {
  return <h1>Страница не найдена (ошибка 404)</h1>
}
